import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  MODAL_SIZES,
  NEWS_COPYRIGHT,
  NEWS_COPYRIGHT_TEXT,
  NEWS_COPYRIGHT_TITLE,
  USAGE_TITLE,
  USAGE_TEXT,
} from 'shared-modules/constants';
import Modal from '../../../../components/Modal';
import styles from './copyrightInfo.module.scss';

const CopyrightInfo = ({ isOpen, closeModal, isOverlap }) => (
  <Modal isOpen={isOpen} closeModal={closeModal} isOverlap={isOverlap} title={USAGE_TITLE} size={MODAL_SIZES.WIDTH_640}>
    <div className={styles.bodyText}>
      <p>{USAGE_TEXT}</p>
      <p>
        {NEWS_COPYRIGHT_TITLE}
        <br />
        {NEWS_COPYRIGHT_TEXT}
        <br />
        {NEWS_COPYRIGHT}
      </p>
    </div>
  </Modal>
);

CopyrightInfo.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isOverlap: PropTypes.bool,
};
CopyrightInfo.defaultProps = {
  isOverlap: false,
};

export default memo(CopyrightInfo);
